import { render, staticRenderFns } from "./BatchLinkedQuesModal.vue?vue&type=template&id=fafe15ce&scoped=true&"
import script from "./BatchLinkedQuesModal.vue?vue&type=script&lang=js&"
export * from "./BatchLinkedQuesModal.vue?vue&type=script&lang=js&"
import style0 from "./BatchLinkedQuesModal.vue?vue&type=style&index=0&id=fafe15ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafe15ce",
  null
  
)

export default component.exports